<template>
  <JyPagebody :activatedLoad="loadData">
    <el-form label-width="140px" size="small" :model="editData" :rules="rules" v-loading="viewLoading" ref="editForm" class="flex-grow-1 overflow-y-auto p-4 bg-white">
      <el-row type="flex" class="flex-wrap">
        <form-item label="网站名称" prop="site_title" fill="4">
          <el-input v-model="editData.site_title"></el-input>
        </form-item>
        <form-item label="网站URL" fill="4">
          <el-input v-model="editData.site_url"></el-input>
        </form-item>
        <form-item label="网站关键字" fill="4">
          <el-input type="textarea" v-model="editData.site_desc" :autosize="{ minRows: 2, maxRows: 6 }"></el-input>
        </form-item>
        <form-item label="网站介绍" fill="4">
          <el-input type="textarea" v-model="editData.site_keyword" :autosize="{ minRows: 2, maxRows: 6 }"></el-input>
        </form-item>
        <form-item label="网站顶部图片" fill="4">
          <div style="line-height:1.3;">
            <div v-if="editData.headerbg" class="d-flex">
              <img :src="rootPath + editData.headerbg" style="height:4rem;" >
              <a href="javascript:;" class="text-danger ml-4" @click="removePic('headerbg')">删除</a>
            </div>
            <el-upload
              class="avatar-uploader company-uploader"
              :headers="headers"
              :action="uploadPic"
              :on-success="function (res, file, filelist) { return handleUploadSuccess(res, filelist, 'headerbg') }"
              :before-upload="beforeUpload">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过20MB，尺寸：1250 × 132</div>
            </el-upload>
          </div>
        </form-item>
        <!-- <form-item label="默认报名须知" fill="4">
          <JyEditor :content="editData.bookinfo" @blur="upateContent1" :params="editData" :uploadHeaders="headers" :z-index="99"
            :uploadParams="{isEditor:'true'}" :uploadImgUrl="uploadPic" :imgOnLoad="editImgOnLoad" has-code />
        </form-item> -->
        <form-item label="网站版权" fill="4">
          <JyEditor :content="editData.site_copyright" @blur="upateContent" :params="editData" :uploadHeaders="headers" :z-index="99"
            :uploadParams="{isEditor:'true'}" :uploadImgUrl="uploadPic" :imgOnLoad="editImgOnLoad" has-code />
        </form-item>
        <form-item label="非授权IP访问提示" fill="4">
          <el-input v-model="editData.iptips"></el-input>
        </form-item>
      </el-row>
    </el-form>
    <div slot="footer">
      <JyButton type="success" @click="doSave" icon="check">保存设置</JyButton>
    </div>
  </JyPagebody>
</template>

<script>
import tools from 'jyutils/tools';
export default {
  components: { },
  mixins: [tools],
  data() {
    return {
      viewLoading: false,
      saveLoading: false,
      fileList: [],
      editImgs: [],
      rules: {
        'site_title': {required:true, message:'网站名称必填！'}
      }
    }
  },
  computed: {
    editUploadImgUrl() {
      return this.rootPath + 'sys/setting/uploadPic';
    }
  },
  beforeRouteLeave (to, from, next) {
    this.confirmSave(
      `未保存网站设置，确定要离开吗？`,
      next,
      () => {
        next(false);
      }
    );
  },
  methods: {
    loadData() {
      this.viewLoading = true;
      this.doGet({
        url: 'sys/setting',
        okcb: (json) => {
          this.editData = json;
          this.fileList = [];
          if (json.headerbg) {
            this.fileList.push({name: json.headerbg, url: this.rootPath + json.headerbg});
          }
          // set origin data for check modified
          this.setOriaData();
        },
        cb: () => {
          this.$nextTick(() => this.viewLoading = false);
        }
      });
      this.editImgs = [];
    },
    handleUploadSuccess(res, filelist, t) {
      if (res.obj && res.obj.pic) {
        this.editData[t] = res.obj.pic;
        filelist.length = 0;
      } else {
        this.$message.error(res.message || '上传出错啦！');
      }
    },
    beforeUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 20;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 20MB!');
      }
      return isJPG && isLt2M;
    },
    removePic(t) {
      this.msgbox('确定要删除吗？', () => {
        this.editData[t] = null;
      })
    },
    editImgOnLoad(json, insertImg) {
      if (json && json.obj && json.obj.pic) {
        let src = json.obj.pic;
        this.editImgs.push(src);
        src = this.rootPath + src;
        insertImg(src);
      }
    },
    upateContent1(html, obj) {
      obj.bookinfo = html;
    },
    upateContent(html, obj) {
      obj.site_copyright = html;
    },
    doSave() {
      this.submitform().then(() => {
        let postData = {};
        this.saveLoading = true;
        Object.assign(postData, this.editData);
        postData.editImgs = this.editImgs;
        this.doPost({
          url: 'sys/setting/save',
          data: postData,
          okcb: () => {
            this.$message.success('保存成功！');
            this.loadData();
          },
          cb: () => {
            this.saveLoading = false;
          }
        });
      })
      .catch(() => {
        
      });
    }
  }
}
</script>
